module.exports = __webpack_public_path__ + "img/device_65les_r2.bec42da9.png";